import { render } from "./AddRocketCoins.vue?vue&type=template&id=815e6e00"
import script from "./AddRocketCoins.vue?vue&type=script&lang=js"
export * from "./AddRocketCoins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__